import { SelectedLines } from "@/models/FCC"
import { v4 as uuidv4 } from "uuid"
import { DiscussionState } from "@/models/Discussions"

interface Params {
  filePathValue: string
  startLineNumber: number | null
  endLineNumber: number | null
  firstSelectedSide: "left" | "right"
  selectedText: string | null
  selectedLines: SelectedLines
}

export const createNewBaseComment = ({
  filePathValue,
  startLineNumber,
  endLineNumber,
  firstSelectedSide,
  selectedText,
  selectedLines
}: Params) => ({
  id: uuidv4(),
  type: "new comment" as const,
  discussion_type: "code",
  author: "",
  author_context: "",
  assignee: null,
  commit_sha: "",
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  outdated: false,
  discussion_state: DiscussionState.Open,
  file: filePathValue,
  end_line: endLineNumber,
  start_line: startLineNumber,
  start_column: null,
  end_column: null,
  comments: [],
  side: firstSelectedSide || "right",
  original_start_line: null,
  original_end_line: null,
  resolved_by: null,
  commented_code: "",
  isDiscussionWaitingForUser: null,
  selectedText: selectedText || null,
  selectedLines
})
